import Galderma from "../../../../src/components/RenderImgs/galdermaImgs";
import * as React from 'react';
export default {
  Galderma,
  React
};